import {
  getLocation,
  LOCATION_CHANGE,
  LocationChangeAction,
} from 'connected-react-router';
import {
  put, PutEffect,
  select, SelectEffect,
  take, TakeEffect,
} from 'redux-saga/effects';

import { fetchPrematchCategories } from 'app/modules/Prematch/actions';

const isPrematch = ({ pathname }: { pathname: string }): boolean => {
  return pathname.startsWith('/prematch');
};

export default function* prematchRefreshSaga(): Generator<
  SelectEffect |
  TakeEffect |
  PutEffect
  > {
  let currentlyInPrematch = yield select((state) => isPrematch(getLocation(state)));

  while (true) {
    const action = (yield take(LOCATION_CHANGE)) as LocationChangeAction;

    const newLocationIsPrematch = isPrematch(action.payload.location);

    if (newLocationIsPrematch && !currentlyInPrematch) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      yield put(fetchPrematchCategories());
    }

    currentlyInPrematch = newLocationIsPrematch;
  }
}
